// extracted by mini-css-extract-plugin
export default {"tagWrapper":"uGax7bAAvMec8qW1wGYG"};